<div class="child-inventory-form" style="height:auto">
  <header class="source-inventory" aria-label="Original inventory">
    <span>Original coffee</span>
    <strong>{{ InventoryItem.InventoryTypeName || 'Coffee reference' }}</strong>
    <small>Ref #{{ InventoryItem.InventoryID }} · {{ availableQty | number }} bags available</small>
  </header>

  <form #boxForm="ngForm"
        class="form-flow" style="height:auto">
    <app-inventory-website-visibility [(invisible)]="WebInvisible"></app-inventory-website-visibility>

    <fieldset class="rms-fieldset">
      <legend>Inventory Data</legend>

      <div class="fields">

        <rms-input type="decimal"
                   name="NetWeight"
                   label="Net Weight"
                   [ngModel]="InventoryItem.NetWeight"
                   [disabled]="true">
        </rms-input>

        <rms-input type="decimal"
                   name="AvailableQty"
                   label="Available Bags"
                   [ngModel]="availableQty"
                   [disabled]="true">
        </rms-input>

        <rms-input type="decimal"
                   name="AvailableWeight"
                   label="Available Weight"
                   [ngModel]="availableWeight"
                   [disabled]="true">
        </rms-input>

      </div>
    </fieldset>


    <fieldset class="rms-fieldset">
      <legend>Create 22lb Boxes By</legend>

      <rms-radio name="Mode"
                 label="Creation Method"
                 [options]="creationModeOptions"
                 [(ngModel)]="Mode"
                 (ngModelChange)="setMode($event)">
      </rms-radio>

      @if (Mode === 'bags') {
      <rms-number name="BagsToUse"
                  label="Number of Bags to Use"
                  [required]="true"
                  [(ngModel)]="BagsToUse">
      </rms-number>
      }

      @if (Mode === 'boxes') {
      <rms-number name="NumberOfBoxes"
                  label="Number of 22lb Boxes"
                  [required]="true"
                  [(ngModel)]="NumberOfBoxes">
      </rms-number>
      }

      @if (Mode === 'weight') {
      <rms-input type="decimal"
                 name="WeightToUse"
                 label="Weight to Use (lbs)"
                 [required]="true"
                 [(ngModel)]="WeightToUse">
      </rms-input>
      }
    </fieldset>

    @if (allocation) {

    <fieldset class="rms-fieldset allocation-preview">
      <legend>Box Allocation</legend>
      <p class="process-note">Royal Line Up boxes appear as children of original reference #{{ InventoryItem.InventoryID }} on the purchase order.</p>

      <div class="allocation-row">
        <span>Bags Affected</span>

        <strong>
          {{ allocation.bagsAffected }}
        </strong>
      </div>


      <div class="allocation-row">
        <span>Weight Used</span>

        <strong>
          {{ allocation.sourceWeight | number:'1.0-2' }} lbs
        </strong>
      </div>


      <div class="allocation-row">
        <span>22lb Boxes Created</span>

        <strong>
          {{ allocation.numberOfBoxes }}
        </strong>
      </div>


      <div class="allocation-row">
        <span>Weight Boxed</span>

        <strong>
          {{ allocation.boxedWeight | number:'1.0-2' }} lbs
        </strong>
      </div>


      @if (allocation.leftoverWeight > 0) {

      <div class="allocation-row leftover">
        <span>Leftover Weight</span>

        <strong>
          {{ allocation.leftoverWeight | number:'1.0-2' }} lbs
        </strong>
      </div>


      <div class="slack-option">

        <rms-checkbox name="SlackRemaining"
                      label="Create Slack From Remaining Weight"
                      [(ngModel)]="SlackRemaining">
        </rms-checkbox>

      </div>


      @if (SlackRemaining) {

      <div class="slack-message sm-font">

        1 slack bag will be created with
        {{ allocation.leftoverWeight | number:'1.0-2' }} lbs.
        It stays in inventory as a Slack child of original reference #{{ InventoryItem.InventoryID }}.

      </div>
      } @else {
        <p class="process-note"><strong>Warehouse instruction:</strong> Send the remaining {{ allocation.leftoverWeight | number:'1.0-2' }} lbs to QC for internal use. No slack inventory child will be created.</p>
      }

      }

    </fieldset>

    }


    @if (validationMessage || errorMessage) {
    <div class="sm-font text-red">
      {{ validationMessage || errorMessage }}
    </div>
    }

  </form>


  <div class="button-container">

    <button mat-button
            class="btn-bg-green"
            [disabled]="!boxForm.valid || !canSave"
            (click)="save()">
      Save
    </button>

    <button mat-button
            class="btn-bg-red"
            (click)="cancel()">
      Cancel
    </button>

  </div>

</div>
